import React from "react";
import {
  Box,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const BlogDetailsScreen = ({ blogUrl, onBack }) => {
  const theme = useTheme();

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: theme.spacing(2),
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <IconButton onClick={onBack}>
          <ArrowBackIosIcon />
        </IconButton>
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
          Blog Details
        </Typography>
      </Box>

      {/* Blog Content in WebView */}
      <Box sx={{ flex: 1 }}>
        <iframe
          src={blogUrl}
          title="Blog Details"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </Box>
    </Box>
  );
};

export default BlogDetailsScreen;